import { Ticker } from '@pixi/ticker';

import LocalisedText, { LocalisedTextOptions } from './LocalisedText';

export class LocalisedTextAnimated extends LocalisedText
{
    private _animate = true;

    constructor(id: string, opts: LocalisedTextOptions)
    {
        super(id, opts);
    }

    public get animate(): boolean
    {
        return this._animate;
    }

    public set animate(v: boolean)
    {
        this._animate = v;
        if (!this._animate) this.scale.set(1);
    }

    public updateTransform(): void
    {
        super.updateTransform();
        if (this._animate)
        {
            this.scale.x = this.textScale + (Math.sin(Ticker.system.lastTime * 0.01) * 0.01);
            this.scale.y = this.textScale + (Math.cos(Ticker.system.lastTime * 0.01) * 0.02);
        }
    }
}
